// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileView__profile-bafd9f {
  --padding: 16px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.ProfileView__media-d85f21 {
  --padding: 16px;
}

.ProfileView__container-b2bc90 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 360px;
  position: relative;
  border-left: 1px solid var(--base-20);
  background-color: var(--base-0);
}

.ProfileView__header-a959b7 {
  display: flex;
  min-height: 72px;
  align-items: center;
  padding: 0 12px;
}

.ProfileView__back-eb5e39 {
  margin-inline-end: 8px;
}

.ProfileView__close-a37fc9 {
  margin-inline-start: auto;
}

.ProfileView__title-b04608 {
  margin-inline-end: 8px;
  margin-inline-start: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
}

.ProfileView__body-c90569 {
  height: 100%;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/RightSidebarManager/components/ProfileView/styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;AACF","sourcesContent":[".profile {\n  --padding: 16px;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.media {\n  --padding: 16px;\n}\n\n.container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  position: relative;\n  border-left: 1px solid var(--base-20);\n  background-color: var(--base-0);\n}\n\n.header {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.back {\n  margin-inline-end: 8px;\n}\n\n.close {\n  margin-inline-start: auto;\n}\n\n.title {\n  margin-inline-end: 8px;\n  margin-inline-start: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n}\n\n.body {\n  height: 100%;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `ProfileView__profile-bafd9f`,
	"media": `ProfileView__media-d85f21`,
	"container": `ProfileView__container-b2bc90`,
	"header": `ProfileView__header-a959b7`,
	"back": `ProfileView__back-eb5e39`,
	"close": `ProfileView__close-a37fc9`,
	"title": `ProfileView__title-b04608`,
	"body": `ProfileView__body-c90569`
};
module.exports = ___CSS_LOADER_EXPORT___;
